/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAiLayers = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M9.49 5.559 6.038 7.5 12 10.853l4.51-2.537.688 1.225 4.786 2.792-4.285 2.5 4.285 2.5-9.48 5.531-.504.293-.504-.293-9.48-5.531 4.284-2.5-4.284-2.5 4.19-2.445L1.96 7.5l6.55-3.684zm3.014 12.305-.504.293-.504-.293-3.21-1.873-2.302 1.342L12 20.842l6.015-3.509-2.301-1.342zM12 13.147l-3.772-2.123-2.244 1.309L12 15.842l6.015-3.509-2.243-1.309zm8.558-9.757L23 5l-2.442 1.61L19 9l-1.559-2.39L15 5l2.441-1.61L19 1zm-2.01 1.2-.137.09-.485.32.485.32.138.09.451.692.451-.692.622-.41-.622-.41L19 3.897z" />
        <path d="m13.336 5.452.084.128.128.084 1.276.836-1.276.836-.128.084-.084.128-.836 1.276-.836-1.276-.084-.128-.128-.084-1.276-.836 1.276-.836.128-.084.084-.128.836-1.276z" />
      </g>
    </g>
  </Icon>
);
export { SvgAiLayers as AiLayers };
